// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3XkWV","row":"Node_row__1vVCz","label":"Node_label__b55km","footer":"Node_footer__34W1s"};